<template>
  <div>
      <div id="searchcontainer">
      <v-row align="center" justify="space-between" class="flex-nowwrap">
        <v-flex shrink><v-row><p style="display: inline; font-size: 12px">{{upcomingBookingsLength}} bookings
          <span v-if="$store.state['overwatch'].includeUnconfirmedBookings && unconfirmedBookingsEnabled">
            &nbsp; {{unconfirmedBookingsLength}}
            <v-chip x-small :color="'#81C784'" text-color="white">unconfirmed</v-chip>
          </span>
          &nbsp; in &nbsp;</p>
        <input
          @input="hoursToShowChanged"
          style="
            display: inline;
            width: 24px;
            font-size: 12px;
            background-color: white;
            text-align: center;
          "
          type="number"
          v-model="hoursToShow"
          v-if="mode == 'default'"
        /><p style="display: inline; font-size: 12px">&nbsp;hours</p></v-row></v-flex>
        <v-flex v-if="mode == 'default'">
          <TableSearch @changed="searchChanged" placeholder='Search Upcoming Bookings' ref="tableSearch" table="upcomingTable" />
        </v-flex>
        <v-flex shrink pl-4 align-self-end>
          <v-btn class="text-none mb-2" style="height: 14px" x-small color="blue" dark @click="changeMode">{{
              mode == "default" ? "All Trips" : "Upcoming Trips"
            }}</v-btn>
        </v-flex>
        <v-flex grow align-self-end>
          <v-card-title class="py-0 my-0">
            <v-spacer></v-spacer>
            <OverwatchFilterPopOver></OverwatchFilterPopOver>
          </v-card-title>
        </v-flex>
        <v-data-footer
          style="height: 24px; margin: 0px !important; padding: 0px !important"
          :pagination="pagination"
          :disable-items-per-page="true"
          :options="options"
          :items-per-page-options="[50]"
          v-if="mode == 'paginated'"
          @update:options="updateOptions"
        ></v-data-footer>
      </v-row>
    </div>
    <div id="gridcontainer" style="width: 100%">
      <table id="upcomingTable" class="upcoming-table" style="width: 100%">
        <thead style="width: 100%">
          <tr id="upcomingTable-header-row">
            <th style="width: 0.75%">Dri</th>
            <th style="width: 02.50%">Pax Lg</th>
            <th style="width: 1%">Time</th>
            <th style="width: 9.90%">Pickup</th>
            <th style="width: 0.25%">Via</th>
            <th style="width: 9.30%">Dest</th>
            <th style="width: 0.35%">Room/Name</th>
            <th style="width: 4.60%">Att</th>
            <th style="width: 0.25%">£</th>
            <th style="width: 0.25%">PTyp</th>
            <th style="width: 0.25%">Dur</th>
          </tr>
        </thead>
        <tbody v-for="booking in upcomingBookings" style="cursor: pointer">
          <v-menu
            offset-y
            max-width="200"
            nudge-right="100"
            :close-on-content-click="false"
            v-model="menu[booking.id.toString()]"
          >
            <template v-slot:activator="{ on }">
              <tr
                v-bind:style="styleForUpcomingBookingRow(booking)"
                @click="setSelectedBooking(booking.id, -1)"
                v-on="on"
                valign="top"
              >
                <td>
                  <p v-if="offeredTaxiForBooking(booking) != ''">
                    {{ offeredTaxiForBooking(booking) }}
                  </p>
                  <div v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div
                          v-on="on"
                          v-html="preassignedDriver(booking)"
                        ></div>
                      </template>
                      <p v-html="preassignedDriverName(booking)"></p>
                    </v-tooltip>
                  </div>
                </td>
                <td class="text-center">
                    <span v-if="booking.num_people > 4" class="pa-1">
                      <v-chip x-small color="#f18a8a" class="pa-1">
                      &nbsp;{{booking.num_people}}&nbsp;
                    </v-chip>
                    </span>
                    <span class="center" v-else>{{booking.num_people}}&nbsp;
                    </span>
                    <span v-if="booking.luggage_count">
                        <v-icon style="margin-bottom: 1px" x-small>mdi-briefcase-outline</v-icon>
                         {{booking.luggage_count}}
                    </span>
                </td>
                <td
                  v-html="
                    timeForBooking(booking.pickup_time) +
                    '&nbsp-&nbsp;' +
                    dispatchTimeForBooking(booking)
                  "
                ></td>
                <td>
                  <div class="fixed-table-row">
                    {{ prettify(booking.pickup_location.description) }}
                  </div>
                </td>
                <td>
                  <ViasForBooking :booking="booking" />
                </td>
                <td>
                  <div class="fixed-table-row">
                    {{ destinationForBooking(booking) }}
                  </div>
                </td>
                <td>
                  <div class="fixed-table-row-truncate">
                    {{ nameOrRoomForCustomerForBooking(booking) }}
                    <v-icon x-small v-if="isVipCustomer(booking)" title="VIP Customer">mdi-star</v-icon>
                  </div>
                </td>
                <td style="overflow: hidden; white-space: nowrap">
                  <AttributesForBookingCell :booking="booking" />
                </td>
                <td>
                  {{
                    driverFinalAfterCommission(booking)
                  }}
                </td>
                <td>
                  {{
                    paymentTypeForBooking(booking)
                  }}
                </td>
                <td>
                  {{
                    booking.route != null
                      ? secondsToHoursMinutesString(booking.route.time)
                      : ""
                  }}
                </td>
                <td style="display:none;">
                  {{ JSON.stringify(booking) }}
                </td>
                <td v-if="booking.preassigned_driver != null" style="display:none;">
                  {{ 'd'+booking.preassigned_driver.driver.callsign }}
                </td>
              </tr>
            </template>
            <BookingMenu
              @copy="copy(booking)"
              @edit="edit(booking.id)"
              @assign="assign(booking.id)"
              @close="menu[booking.id.toString()] = false"
              @track="setSelectedBooking(booking.id, -1)"
              :booking="booking"
            />
          </v-menu>
          <tr
              id="lastPriorityBooking"
              style="
                max-height: 30px !important;
                background-color: black !important;
              "
              v-if="isLastPriorityBooking(booking.id)"
            >
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BookingMenu from "@/components/widget/menu/BookingMenu.vue";
import AttributesForBookingCell from "@/components/widget/AttributesForBookingCell.vue";
import TableSearch from "@/components/overwatch/TableSearch.vue";

import moment from "moment";
import ViasForBooking from "@/components/overwatch/ViasForBooking.vue";

import { Overwatch } from "@/components/util/Overwatch.js";

import { replaceStart } from "@/components/util/PhoneNumbers.js";
import OverwatchFilterPopOver from '@/components/overwatch/filters/OverwatchFilterPopOver'
export default {
  name: "upcoming_trip_table",
  components: {
    OverwatchFilterPopOver,
    AttributesForBookingCell,
    TableSearch,
    BookingMenu,
    ViasForBooking,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    taxis: Array,
    bookings: Array,
    setSelectedBooking: Function,
    selectedBooking: Number,
    showAssign: Function,
    hoursToShow: Number,
    mode: String,
    pagination: Object,
  },
  watch: {
    bookings: function () {
      // console.log("Bookings search");
      try {
        this.$refs.tableSearch.searchTable();
      } catch (e) {}
    },
  },
  computed: {
    dispatchConfiguration () {
      return this.$store.getters['dispatch/getDispatchConfiguration']
    },
    unconfirmedBookingsConfig () {
      return (this.dispatchConfiguration ? this.dispatchConfiguration.unconfirmed_booking_configuration : null)
    },
    unconfirmedBookingsEnabled () {
      return (this.unconfirmedBookingsConfig ? this.unconfirmedBookingsConfig.enabled : false)
    },
    isMenuOpen () {
      let values = Object.values(this.$store.state.bookingMenu)
      let isOpen =  values.find(val => {
        return val == true
      })
      if (isOpen) {
        return true
      }
      return false
    },
    isDispatchCmr () {
      return this.$store.state.apiUrl.includes('cmr') || this.$store.state.apiUrl.includes('dispatch.cmr')
    },
    upcomingBookings: function () {

      var self = this;

      var filters = this.$store.getters['overwatch/getBookingTypesFilter'];

      var upcomingBookings = this.bookings.filter(function (b) {
        if (filters.length == 0 || self.search != "") {
          return (b.state == "booked" || b.state == "unconfirmed");
        } else if (filters.includes(b.booking_type)) {
          return (b.state == "booked" || b.state == "unconfirmed");
        }
      });

      var sort = this.sortUpcomingBookings;

      return upcomingBookings.sort(sort);
    },
    bookingTypesFilter () {
      return this.$store.getters['overwatch/getBookingTypesFilter']
    },
    upcomingBookingsLength: function () {

      var filters = this.$store.getters['overwatch/getBookingTypesFilter'];

      return this.bookings.filter(function (b) {
        if (filters.length == 0) {
          return (b.state == "booked" || b.state == "unconfirmed");
        } else if (filters.includes(b.booking_type)) {
          return (b.state == "booked" || b.state == "unconfirmed");
        }
      }).length;
    },
    unconfirmedBookingsLength: function () {
      return this.bookings.filter(function (b) {
        return (b.state == "unconfirmed" );
      }).length;
    },
  },
  data() {
    return {
      defaultCommissionPercentage: 20,
      ABOUT_TO_CLEAR_TIME: 1,
      menu: {},
      options: { itemsPerPage: 50, page: null },
      search: ''
    };
  },
  methods: {
    searchChanged( val ) {
      this.search = val;
    },
    getRideTypeShortName(rideTypeName) {
      const firstLetters = rideTypeName
        .split(' ')
        .map(word => word[0])
        .join('');
      return firstLetters.toUpperCase();
    },
    isFinishable(booking) {
    return booking.preassigned_driver && booking.payment_type != 'card' ? true : false
    },
    isLastPriorityBooking: function(id) {

      if (this.upcomingBookings == null || this.upcomingBookings.length == 0) {
        return -1;
      }

      var lastPriorityBookingID = -1;

      for (var i = 0; i < this.upcomingBookings.length; i++) {
        if (this.upcomingBookings[i].priority == true) {
          lastPriorityBookingID = this.upcomingBookings[i].id;
        }
      }

      return lastPriorityBookingID == id;
    },
    numPeople: function(booking) {
      if (booking.num_people > 4) {
        return '<div class="circle">' + booking.num_people + "</div>"
      } else {
        return '<div class="center">' + booking.num_people + "</div>";
      }
    },
    paymentTypeForBooking: function(booking) {
      if (booking.payment_type == 'card') {
        if (booking.card_payment_type != null && booking.card_payment_type == "prepaid") {
          return "paid";
        } else {
          return "card";
        }
      } else if (booking.payment_type == 'account') {
        return "acc";
      } else if (booking.payment_type == 'card_in_cab') {
        return "cic";
      } else if (booking.payment_type == 'cash') {
        return "cash";
      }
    },
    driverFinalAfterCommission: function (booking) {
      if (booking.fixed_cost_driver || booking.final_fare || booking.estimated_cost) {
        var finalFare = booking.fixed_cost_driver;
        if(!finalFare) {
          finalFare = booking.final_fare
        }
        if(!finalFare) {
          finalFare = booking.estimated_cost
        }
        if (finalFare) {
          if (booking.fixed_commission != null && booking.fixed_commission > 0) {
            finalFare -= booking.fixed_commission
          } else if (booking.fixed_commission == 0) {
            finalFare -= booking.fixed_commission
          } else if (booking.preassigned_driver && booking.preassigned_driver.driver && booking.preassigned_driver.driver.fee_percentage ) {
            finalFare -= (booking.preassigned_driver.driver.fee_percentage/100.0) * finalFare
          } else {
            finalFare -= (this.defaultCommissionPercentage/100) * finalFare
          }
        }
        if (finalFare != 0 && finalFare != null) {
          return ((finalFare/100)).toFixed(2);
        }
      }
      return (booking.estimated_cost/100).toFixed(2)
    },
    costForBooking: function(booking) {
      var cost = 0;

      if (booking.final_cost_promotion != null && booking.final_cost_promotion != 0) {
        cost = booking.final_cost_promotion;
      } else if (booking.final_cost != null && booking.final_cost != 0) {
        cost = booking.final_cost;
      } else if (booking.estimated_cost_promotion != null &&  booking.estimated_cost_promotion != 0) {
        cost = booking.estimated_cost_promotion;
      } else if (booking.estimated_cost != null && booking.estimated_cost != 0) {
        cost = booking.estimated_cost;
      }

      if (cost == 0) {
        return "";
      }

      return (cost / 100.0).toFixed(2)
    },
    updateOptions: function (e) {
      console.log(e);
      this.$emit("changePage", e.page);
    },
    changeMode: function () {
      if (this.mode == "default") {
        this.$emit("changeMode", "paginated");
      } else {
        this.$emit("changeMode", "default");
      }
    },
    isVipCustomer (b) {
      return b.vip_customer ? b.vip_customer == true : false
    },
    nameOrRoomForCustomerForBooking: function (b) {
      
      if (b.room_number != null && b.room_number != "" && b.business_customer_name != null && b.business_customer_name != "") {
        return b.room_number + " - " + b.business_customer_name.substring(0, Math.min(5, b.business_customer_name.length)); ; 
      } else if (b.business_customer_name != null && b.business_customer_name != "") {
        return b.business_customer_name;
      } else if (b.room_number != null && b.room_number != "") {
        return b.room_number + " - " + b.customer_name.substring(0, Math.min(5, b.customer_name.length));
      } else {
        return b.customer_name;
      }
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    hoursToShowChanged: function () {
      if (this.hoursToShow > 72) {
        this.$snackbar.warning("You can not look ahead for more than 72 hours. Please use bookings list page to manage future bookings. Thank You.")
        return;
      }
      this.$emit("changeHoursToShow", Number(this.hoursToShow));
    },
    copy: function (booking) {
      this.$emit("copy", booking);
    },
    edit: function (bookingID) {
      this.$emit("edit", bookingID);
    },
    assign: function (bookingID) {
      this.$emit("assign", bookingID);
    },
    callsignPrefixForDriver(driver) {
      var group = "";

      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driver_group_id == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].callsignPrefix;
        }
      }
      
      return group;
    },
    preassignedDriver: function (booking) {
      try {
        if (booking.preassigned_driver != null) {
          var preassignedString = "";
          if (
            !new Overwatch(this.taxis, this.bookings).driverIsOnline(
              booking.preassigned_driver.driver.id
            )
          ) {
            preassignedString +=
              "<div style='padding-top: 2px; background-color: #dadada; border-radius: 8px;'><p align='center'>";
          } else {
            preassignedString +=
              "<div style='padding-top: 2px; background-color: white; border-radius: 8px;'><p align='center'>";
          }

         preassignedString += "<b>";

          if (booking.preassigned_driver.assignment_type == "assignment_type_bid") {
            preassignedString += "b"
          }

          preassignedString += this.callsignPrefixForDriver(booking);
          preassignedString += booking.preassigned_driver.driver.callsign
          
          preassignedString += "</b>";

          preassignedString += "</a></div>";
          return preassignedString;
        } else {
          return "";
        }
      } catch (e) {
        console.log(e);
      }
      return ""
    },
    preassignedDriverName: function (booking) {
      if (booking.preassigned_driver != null) {
        return booking.preassigned_driver.driver.name;
      } else {
        return "";
      }
    },
    isBookingFromMillers(booking) {
      if (booking.operator && booking.operator.toLowerCase().includes("miller")) {
        return true;
      }
      return false
    },
    offeredTaxiForBooking: function (booking) {
      var taxiID = null;

      if (
        booking.has_follow_on_offer &&
        booking.follow_on_job_offer_taxis != null
      ) {
        // get follow on taxis for booking
        taxiID = booking.follow_on_job_offer_taxis;
      } else if (booking.offer_taxis != null) {
        taxiID = booking.offer_taxis;
      }

      if (taxiID != null) {
        var taxi = this.taxis.find(function (t) {
          return t.id == taxiID;
        });

        if (taxi != null) {
          return this.callsignPrefixForDriver(taxi) + taxi.driver.callsign;
        }
      }

      return "";
    },
    styleForUpcomingBookingRow: function (booking) {
      // if being offered return
      var color = "white";

      if(booking.driver_compliant === false) {
        var style = {
          "background-color": "#FFC0CB",
        };
        return style
      }
      
      if (booking.state == 'unconfirmed') {
         color = this.$colorsConfig.getUnconfirmedBookingColor()
        var style = {
          "background-color": color,
        };
        return style
      }

      if (booking.priority) {
        color = "#add8e6"
      }
      
      if (this.isVipCustomer(booking)) {
        color = '#E0C6FF'
      }

      if (booking.taxi) {
        color = "#6cffbb";
      } else if (booking.has_follow_on_offer) {
        color = "#6cffbb";
      } else {
        if (booking.asap || booking.estimated_dispatch_timestamp == null) {
          dispatchTimeMillis = booking.pickup_timestamp;
        } else {
          dispatchTimeMillis = booking.estimated_dispatch_timestamp;
        }

        var now = moment(new Date());
        var end = moment(dispatchTimeMillis);

        var dispatchTimeMillis = 0;

        var lateString = "";

        var diff = now.diff(end);

        var duration = moment.duration(diff);

        var minutes = duration.asMinutes();

        // console.log(minutes);

        // 10 minute threshold for running late
        if (booking.asap && minutes >= 9.5) {
          color = "#ff6c6c";
        } else if (!booking.asap && minutes >= -10) {
          color = "#fcbd68";
        }
      }
      
      if (this.offeredTaxiForBooking(booking) == "" && this.preassignedDriver(booking) == "" && this.nameOrRoomForCustomerForBooking(booking).toLowerCase().includes("scc") && this.isDispatchCmr) {
        color = '#f6c5c5'
      }
      
      var style = {
        "background-color": color,
      };

      if (this.selectedBooking == booking.id) {
        style.boxShadow = "inset 0 0 0 99999px rgba(0,0,0,0.15)";
      }

      return style;
    },
    timeForBooking: function (timeString) {
      var time = moment(timeString, "DD/MM/YYYY HH:mm");

      return `${time.format("HH:mm")}`;
    },
    dispatchTimeForBooking: function (booking) {
      if (booking.asap) {
        return "<b class='blink_me' style='color: red'>ASAP</b>";
      }

      var dispatchTimeMillis = 0;
      dispatchTimeMillis = booking.pickup_timestamp;

      var now = moment(new Date());
      var end = moment(dispatchTimeMillis);

      // console.log(now);
      // console.log(end);

      var lateString = "";

      if (now.isAfter(end)) {
        // lateString = " ago";
      }

      var diff = now.diff(end);

      var duration = moment.duration(diff);

      var lateTimeString = this.durationToHoursMinutesString(duration, "m");

      if (!end.isSame(new Date(), "day") && !now.isAfter(end)) {
        lateTimeString = end.format("DD/MM");
      }

      return lateTimeString + lateString;
    },
    durationToHoursMinutesString: function (duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    secondsToHoursMinutesString: function (seconds) {
      var duration = moment.duration(seconds, "seconds");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    },
    prettify: function (d) {
      return Overwatch.prettifyAddress(d);
    },
    viasForBooking: function (b) {
      return Overwatch.viasForBooking(b);
    },
    destinationForBooking: function (b) {
      return Overwatch.destinationForBooking(b);
    },
    sortUpcomingBookings: function (a, b) {
 

      var dispatchTimeA = 0;
      var dispatchTimeB = 0;
      if (a.state === 'unconfirmed' && b.state !== 'unconfirmed') {
        return -1;
      } else if (a.state !== 'unconfirmed' && b.state === 'unconfirmed') {
        return 1;
      }
      
      if (a.asap) {
        dispatchTimeA = a.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeA = a.estimated_dispatch_timestamp;
        } else {
          dispatchTimeA = a.pickup_timestamp;
        }
      }

      if (b.asap) {
        dispatchTimeB = b.pickup_timestamp;
      } else {
        if (a.estimated_dispatch_timestamp != null) {
          dispatchTimeB = b.estimated_dispatch_timestamp;
        } else {
          dispatchTimeB = b.pickup_timestamp;
        }
      }
  
      if (a.priority && !b.priority) {
        return -1;
      } else if (b.priority && !a.priority) {
        return 1;
      }

      if (dispatchTimeA < dispatchTimeB) {
        return -1;
      } else if (dispatchTimeA > dispatchTimeB) {
        return 1;
      } else {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        } else {
          return 0;
        }
      }
      // }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#gridcontainer {
  position: absolute;
  top: 24px;
  bottom: 0px;
  left: 0;
  right: 0;
  overflow: auto;
}

#searchcontainer {
  position: absolute;
  width: 100%;
  height: 24px;
  top: 0px;
  left: 0;
  padding-top: 1px;
  padding-left: 8px;
  right: 0;
  background-color: #f5f5f5;
}

.upcoming-table {
  font-size: 11px;
}

th {
  text-align: left;
  color: #10425a;
}

th,
td {
  text-align: left;
  padding-left: 8px;
  padding-top: 1px;
}

tr {
  padding-top: 3px !important;
}

table {
  padding: 4px;
  border-collapse: collapse;
}

// tr:nth-child(even) {
//   background-color: #f2f2f2;
// }

tbody:nth-child(even) {
  background-color: #f2f2f2;
}

.via-list {
  list-style: disc !important;
  padding-left: 14px !important;
}

.taxi-list-header {
  color: #10425a;
}

.small-text {
  font-size: 13px;
}

.padding-li {
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
}

.padding-li:hover {
  background-color: #dedede;
}

.no-text-overflow {
  // overflow: hidden;
  // white-space: nowrap;
  // text-overflow: none;
}

.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.v-btn--icon.v-size--default {
  height: 24px !important;
  width: 24px !important;
}

.circle {
  width: 16px;
  height: 16px;
  line-height: 15px;
  border-radius: 50%;
  background: #FFBB96;
  text-align: center;
}

.center { width: 16px;
  height: 16px;
  text-align: center;
}
</style>
